<template>
    <div class="lottery-item-wrapper">
        <div class="prize-name">
            <div>{{ prizeName[0] }}</div>
            <div v-if="prizeName[1]">{{ prizeName[1] }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        prizeInfo: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        prizeName() {
            const name = [];
            if (this.prizeInfo.name.indexOf('现金') > -1) {
                name.push(this.prizeInfo.name.replace('现金', ''));
                name.push('现金');
            }
            else if (this.prizeInfo.name.indexOf('金币') > -1) {
                name.push(this.prizeInfo.name.replace('金币', ''));
                name.push('金币');
            }
            else {
                name.push(this.prizeInfo.name);
            }
            return name;
        }
    },
    methods: {}

};
</script>
<style lang='scss' scoped>
.lottery-item-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    .prize-name {
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #fff;
        text-shadow: 0 0 4px #62fbff;
        width: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}
</style>